// ts-gql-integrity:90e609ecc6e5b4a0ab567dd24847b104
/*
ts-gql-meta-begin
{
  "hash": "bce9c149ac5cd26238937fd0fe9db750"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type User_ManagerFragment = { readonly __typename: 'TenantUser', readonly manager: boolean | null };



export type type = TypedDocumentNode<{
  type: "fragment";
  result: User_ManagerFragment;
  name: "User_Manager";
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    User_Manager: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"User_Manager\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"TenantUser\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"__typename\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"manager\"},\"arguments\":[],\"directives\":[]}]}}]}")
